export default function Footer() {
  const footerLinks = [
    { label: '首页', href: '#hero' },
    { label: '平台特色', href: '#features' },
    { label: '焦点专题', href: '#carousel' },
    { label: '吃瓜排行', href: '#ranking' },
    { label: '热门话题', href: '#topics' },
    { label: '吃瓜问答', href: '#faq' },
    { label: '主题索引', href: '#index' },
    { label: '联系我们', href: '#contact' },
  ];

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <a href="#hero" className="inline-block no-underline mb-4">
              <span className="text-2xl font-heading font-bold text-primary-400 whitespace-nowrap">
                每日大赛<span className="text-background-100">mrds</span>
              </span>
            </a>
            <p className="text-sm text-background-300 leading-relaxed max-w-sm">
              每日大赛mrds是国内领先的每日吃瓜排位赛平台，汇聚全网最新黑料评选与实时爆料排行，追踪热点话题和娱乐梗图，吃瓜大赛一触即发。
            </p>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-heading font-bold text-background-100 mb-4">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap no-underline"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-heading font-bold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              我们与多家娱乐资讯平台、自媒体矩阵及内容创作社区保持紧密合作，共同打造优质的吃瓜评选生态。
            </p>
            <div className="mt-6">
              <p className="text-sm text-background-400 mb-1">投稿 / 爆料：</p>
              <a href="#contact" className="text-sm text-primary-400 hover:text-primary-300 transition-colors no-underline whitespace-nowrap">
                点击进入投稿入口 &rarr;
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 每日大赛mrds. 本站内容仅供娱乐参考。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline whitespace-nowrap">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}